export default __webpack_public_path__ + "static/media/gfgproject.447291e8.png";